"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* https://confluence.tunein.com/display/ENG/TuneIn.com+Release+Versioning */
var versionBreak = 100;
var versionBreakMinusOne = versionBreak - 1;
var branchMap = {
  1: 'release',
  2: 'hotfix',
  3: 'minor-release',
  release: '1',
  hotfix: '2',
  'minor-release': '3'
};

function incrementHelper(nextVerIntArray) {
  var nextVersion = nextVerIntArray;

  if (nextVersion[1] === versionBreakMinusOne) {
    // if _.x._ is last valid version
    ++nextVersion[0]; // increment x._._

    nextVersion[1] = 0; // set _.0._
  } else {
    ++nextVersion[1]; // increment _.x._
  }

  nextVersion[2] = 0; // set _._.0

  return nextVersion;
}

function calculateNextReleaseSemver(releaseOrHotfix, currentVersion) {
  var nextVerStringArray = currentVersion.split('.');
  var nextVerIntArray = [];
  nextVerStringArray.forEach(function (e) {
    nextVerIntArray.push(parseInt(e, 10));
  });

  if (releaseOrHotfix === branchMap.release) {
    // if release/hotfix, always increment
    nextVerIntArray = incrementHelper(nextVerIntArray); // x.0.0 or _.x.0
  } else {
    // if minor release

    /* eslint-disable no-lonely-if */
    if (nextVerIntArray[2] === versionBreakMinusOne) {
      // if _._.x is last valid version, increment
      nextVerIntArray = incrementHelper(nextVerIntArray); // x.0.0 or _.x.0
    } else {
      ++nextVerIntArray[2]; // increment _._.x
    }
  }

  return "".concat(nextVerIntArray[0], ".").concat(nextVerIntArray[1], ".").concat(nextVerIntArray[2]);
}

function calculateReleaseVersion(releaseVersion) {
  var versions = releaseVersion.split('.');
  var major = parseInt(versions[0], 10);
  var minor = parseInt(versions[1], 10) / versionBreak;
  var patch = parseInt(versions[2], 10) / (100 * versionBreak); // rounding to avoid potential floating-point rounding errors
  // https://floating-point-gui.de/basic/

  return parseFloat((major + minor + patch).toFixed(4));
}

var _default = {
  branchMap: branchMap,
  calculateNextReleaseSemver: calculateNextReleaseSemver,
  calculateReleaseVersion: calculateReleaseVersion
};
exports.default = _default;